import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { ShowMoreButtonDesktop as ShowMoreButton } from '../show-more-button/desktop';

import type { TResultsDesktop, IDepsDesktop } from './models';
import { SearchItem } from './search-item';
import { Results as Component } from './results';
import styles from './styles/desktop.css';

export const ResultsDesktop = createWidget<IDepsDesktop, TResultsDesktop>({
    styles,
    ShowMoreButton,
    SearchItem,
})(Component);
